import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  VertCarousel, VertContainer, Row, Col, VertImage, VertSkeleton,
} from '@vertem-core/vertice-ds';
import { useSelector } from 'react-redux';
import PipeProvider from 'Services/Providers/PipeProvider';
import { filterTradeMenuByType } from 'Utils/filterTradeMenuByType';
import isExternalLink from 'Utils/isExternalLink';
import { Link } from 'react-router-dom';
import 'Assets/styles/default/components/ShowcaseServices/index.less'
import useSegmentId from 'Hooks/useSegmentId';

const getClassByQtyServices = (ShowcaseItemsQty) => {
  if (ShowcaseItemsQty) {
    if (ShowcaseItemsQty > 2) {
      return 3
    } else if (ShowcaseItemsQty === 2) {
      return 2
    } else if (ShowcaseItemsQty === 1) {
      return 1
    }
  }
  return 3
}
const getSrcByQtyServices = (ShowcaseItemsQty) => {
  if (ShowcaseItemsQty > 2) {
    return '-peq';
  } else if (ShowcaseItemsQty === 2) {
    return '-med';
  } else if (ShowcaseItemsQty === 1) {
    return '-gde';
  }
  return '-gde';
}

const getSettingsSlick = (QtyServices) => {
  const slidesToShow = getClassByQtyServices(QtyServices);
  const infinite = getClassByQtyServices(QtyServices) > 2;
  const arrows = getClassByQtyServices(QtyServices) > 2;
  const centerMode = getClassByQtyServices(QtyServices) > 2;
  const centerPadding = (getClassByQtyServices(QtyServices) > 2 ? '30px 0px 0px 0px' : '0px')

  return {
    slidesToShow: slidesToShow,
    infinite: infinite,
    dots: false,
    arrows: arrows,
    centerMode: centerMode,
    centerPadding: centerPadding,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode:centerMode,
          centerPadding: "30px 0px 0px 0px"
        }
      },
    ]
  };
}

const getFilteredTradeMenu = (CmsStatic, type) => {
  const { cms: { tradeMenu } } = CmsStatic;
  const targetType = type;
  const filteredItem = filterTradeMenuByType(tradeMenu, targetType);
  return filteredItem;
}

const ShowcaseServicesWrapper = ({ QtyServices, children }) => {
  let settings = {};
  if (QtyServices > 0) {
    settings = getSettingsSlick(QtyServices);
  }


    return (
      <VertContainer data-testid="vert-box-showcase" className="vert-box-showcase vert-box-showcase-services  margin-bottom-big" spacingX='regular'>
        <Row className="vert-showcase-wrapper vert-showcase-services" gutter={8} spacing={'small'}>
            {
              QtyServices > 0 ? (
                <div  className='w-100'>
                  <VertCarousel { ...settings }>
                    {children}
                  </VertCarousel>
                </div>
              ) : (
                <div  className='w-100'>
                  {children}
                </div>
              )
            }
        </Row>
      </VertContainer>
    );
  };
ShowcaseServicesWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  slidesToShow: PropTypes.number
};


const CreateLink = ({ children, url, target="_self" }) => {
  if (isExternalLink(url)) {
    return <a href={url} target={target}>
      { children }
    </a>
  } else {
    return <Link to={url || '#'} target={target}>
      { children }
    </Link>
  }
}

const ShowcaseServices = ({ type }) => {

  const CmsStatic = useSelector(({ CmsStatic: data }) => data);
  const [servicesItem, setServicesItem] = useState([]);

  const { segmentId } = useSegmentId()

  useEffect(() => {
    if (CmsStatic?.requestMake && !CmsStatic?.isLoading) {
      const filteredShowcaseItems = getFilteredTradeMenu(CmsStatic, type);
      setServicesItem(filteredShowcaseItems);
    }
  }, [CmsStatic?.requestMake]);


  const sizeImage = getSrcByQtyServices(servicesItem.length);
  const items = servicesItem.map((item, index) => {
    const { icon, label, path } = item;
    let imageSrc = icon;
    if (type === 'services') {
      imageSrc = icon + sizeImage + '.png';
    }
    return (
      <Col span={24} key={index} className="card-service padding-top-regular">
        <CreateLink url={path}>
          <VertImage
            src={imageSrc}
            className={label}
            fallback="https://vertice-ds.s3.amazonaws.com/Assets/Images/fallbacks/fallback-img-store.png"
            placeholder="https://vertice-ds.s3.amazonaws.com/Assets/Images/fallbacks/fallback-img-store.png"
          />
        </CreateLink>
      </Col>
    );
  });

  return (
    <PipeProvider
        apiSymbols={[{ symbol: 'FETCH_CMS_STATIC', alias: 'cmsMenu', payload: {
          segment: segmentId
          } }]}
        loadingComponent={
            <VertSkeleton paragraph={{ rows: 1 }} active title={false} />
        }
    >
        <ShowcaseServicesWrapper QtyServices={servicesItem.length}>
          { servicesItem.length > 0 ? items : '' }
        </ShowcaseServicesWrapper>
    </PipeProvider>
  );
};

ShowcaseServices.propTypes = {
  type: PropTypes.string.isRequired
};

export default ShowcaseServices;
